import { SimpleItemProps } from "../../../../../ootr/inventory/items/SimpleItemProps";
import Item, { ItemSharedProps } from "../../../../items/Item";
import StaticItem from "../../../../items/StaticItem";
import CUp from "../cup.png";



const ButtonCUpItem = (props: ItemSharedProps) => {

    return <Item {...props} id="ButtonCUp" image={CUp} title="C-Up" />
}

export default ButtonCUpItem;

export const SimpleButtonCUpItem = (props: SimpleItemProps) => {

     return <StaticItem
        image={CUp}
        onClick={props.onClick}
        name={"SimpleMaskOfTruthItem"}
    />




}